<template>
  <section v-if="!isLoggedIn">
    <p class="text-center pt-3"><q><em>{{ quote }}</em></q></p>
    <div v-if="successRegistration" class="alert alert-success text-center" role="alert">
      <span class="font-size-xl">Registered successfully !</span><br>
      <span>You will be redirect shortly to the login page...</span>
    </div>
    <div v-if="!successRegistration" class="d-flex flex-column flex-lg-row m-2">
      <div class="w-100 w-lg-50 bg-img leftContent">
        <div class="h-100 overlay pt-4 pb-2">
          <div class="p-2 d-flex flex-column justify-content-center divLogo rounded-circle">
            <img alt="log_app" src="../assets/logo_2.png" class="d-block img-fluid">
          </div>
          <article class="pt-2 pl-4 pr-4">
            <h1 class="text-center font-weight-bold font-size-xl"><i>Hey There !</i></h1>
            <p class="font-size-lg">
              <span>Are you a client of ATI  or have you already subscribed to one of our insurance plan ?</span>
            </p>
            <p><span>If yes, please <router-link to="/" class="text-white text-underline">sign-in</router-link> with your credentials.</span></p>
            <p><span>If no, please fill-in the following form with your personal data.</span></p>
          </article>
        </div>
      </div>
      <div class="w-100 w-lg-50 rightContent">
        <div class="d-flex justify-content-center mt-2">
          <h1 class="w-95 p-2 bg-color-grey border rounded text-center text-white font-size-xxl">Register Form</h1>
        </div>
        <form @submit.prevent="onSubmit" class="w-95">
          <div class="input-group mt-4">
            <label for="name" class="d-none"></label>
            <input @blur="$v.userDataForm.name.$touch()" v-model="userDataForm.name" type="text" name="name" id="name" class="form-control" placeholder="*Name">
            <div class="divIconInput">
              <font-awesome-icon icon="user" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.name.$error">
            <span v-if="!$v.userDataForm.name.minLength" class="text-danger">* Your name must be at least {{ $v.userDataForm.name.$params.minLength.min }} characters long !</span>
            <span v-if="!$v.userDataForm.name.required" class="text-danger">* Please enter your name !</span>
          </div>
          <div class="input-group">
            <label for="surname" class="d-none"></label>
            <input @blur="$v.userDataForm.surname.$touch()" v-model="userDataForm.surname" type="text" name="surname" id="surname" class="form-control" placeholder="*Surname">
            <div class="divIconInput">
              <font-awesome-icon icon="user" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.surname.$error">
            <span v-if="!$v.userDataForm.surname.minLength" class="text-danger">* Your surname must be at least {{ $v.userDataForm.surname.$params.minLength.min }} characters long !</span>
            <span v-if="!$v.userDataForm.surname.required" class="text-danger">* Please enter your surname !</span>
          </div>
          <div class="input-group">
            <label for="phonenumber" class="d-none"></label>
            <input @blur="$v.userDataForm.phonenumber.$touch()" v-model="userDataForm.phonenumber" type="number" name="phonenumber" id="phonenumber" class="form-control" placeholder="Telephone">
            <div class="divIconInput">
              <font-awesome-icon icon="phone" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.phonenumber.$error">
            <span v-if="!$v.userDataForm.phonenumber.numeric" class="text-danger">You have to enter digit number !</span>
            <br v-if="!$v.userDataForm.phonenumber.numeric && !$v.userDataForm.phonenumber.minLength">
            <span v-if="!$v.userDataForm.phonenumber.minLength" class="text-danger">Your phone number should contain {{ $v.userDataForm.phonenumber.$params.minLength.min }} digits  !</span>
          </div>
          <div class="input-group">
            <label for="address" class="d-none"></label>
            <input @blur="$v.userDataForm.address.$touch()" v-model="userDataForm.address" type="text" name="address" id="address" class="form-control" placeholder="Home Address">
            <div class="divIconInput">
              <font-awesome-icon icon="map-marked-alt" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.address.$error">
            <span v-if="!$v.userDataForm.address.minLength" class="text-danger">Your home address has to be {{ $v.userDataForm.address.$params.minLength.min }} characters long  !</span>
          </div>
          <div class="input-group">
            <label for="email" class="d-none"></label>
            <input @blur="$v.userDataForm.email.$touch()" v-model="userDataForm.email" type="email" name="email" id="email" class="form-control" placeholder="*Email Address">
            <div class="divIconInput">
              <font-awesome-icon icon="envelope" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.email.$error">
            <span v-if="!$v.userDataForm.email.email" class="text-danger">* Please provide a valid email address !</span>
            <span v-if="!$v.userDataForm.email.required" class="text-danger">* Please enter an email address !</span>
          </div>
          <div class="input-group">
            <label for="password" class="d-none"></label>
            <input @blur="$v.userDataForm.password.$touch()" v-model="userDataForm.password" type="password" name="password" id="password" class="form-control" placeholder="*Password">
            <div class="divIconInput">
              <font-awesome-icon icon="lock" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.password.$error">
            <span v-if="!$v.userDataForm.password.minLength" class="text-danger">* Password must have at least {{ $v.userDataForm.password.$params.minLength.min }} characters !</span>
            <span v-if="!$v.userDataForm.password.required" class="text-danger">* Please enter your password !</span>
          </div>
          <div class="input-group">
            <label for="confirmpassword" class="d-none"></label>
            <input @blur="$v.userDataForm.confirmpassword.$touch()" v-model="userDataForm.confirmpassword" type="password" name="confirmpassword" id="confirmpassword" class="form-control" placeholder="*Repeat Password">
            <div class="divIconInput">
              <font-awesome-icon icon="lock" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.confirmpassword.$error">
            <span v-if="!$v.userDataForm.confirmpassword.sameAs" class="text-danger">* Please match your password !</span>
          </div>
          <div class="text-center mb-5">
            <button type="submit" class="mt-5 btn bg-color-grey text-white" :disabled="$v.userDataForm.$invalid">Sign-Up</button>
            <div class="divEmptyBox text-center" v-if="$v.userDataForm.$invalid" v-on:click="$store.state.invalidFormAlert">
              <div class="emptyBox"><span class="invisible">Sign-Up</span></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { FORM_SIGNUP } from '../validations/formRegister'
import router from '../router'

export default {
  name: 'Register',
  data () {
    return {
      quote: this.$store.state.quotes[Math.floor(Math.random() * this.$store.state.quotes.length)],
      userDataForm: {
        name: '',
        surname: '',
        phonenumber: '',
        address: '',
        email: '',
        password: '',
        confirmpassword: ''
      },
      successRegistration: false,
      isLoggedIn: false
    }
  },
  // check if user is logged in or not.
  created () {
    if (this.$store.state.token) {
      this.isLoggedIn = true
      router.back()
    }
  },
  methods: {
    // Post new user after finishing filling the form
    onSubmit () {
      const formData = {
        name: this.userDataForm.name,
        surname: this.userDataForm.surname,
        phonenumber: this.userDataForm.phonenumber,
        address: this.userDataForm.address,
        email: this.userDataForm.email,
        password: this.userDataForm.password,
        confirmpassword: this.userDataForm.confirmpassword
      }
      console.log(formData)
      this.$store.dispatch('sign_up', formData)
        .then(isSuccess => {
          isSuccess === true ? this.successRegistration = true : this.successRegistration = false
          setTimeout(() => {
            router.replace('/login')
          }, 3000)
          console.log('response axios post login = ' + isSuccess)
        })
    }
  },
  // Load validations requirements of the registration form
  validations: FORM_SIGNUP
}
</script>

<style scoped>
@import "../assets/css/loginRegister.css";
.bg-img{
  background-image: url(../assets/img/img-register.jpg);
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue